export default __webpack_public_path__ + "f35dd6930b37fb6ed0f5d1b7b83b860d.svg";